import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../css/login.css'
import logo from '../images/logo.jpg'

export class Login extends Component {
    render() {
        let d = new Date();
        return (
            <div className="text-center" id="login-div">
                <form className="form-signin">
                    <img className="mb-4" src={logo} alt="" width="100" height="100" />
                    <h1 className="h3 mb-3 font-weight-normal">Lead Management Tool <small>v1.0.0</small></h1>
                    <label htmlFor="inputEmail" className="sr-only">Email address</label>
                    <input type="email" id="inputEmail" className="form-control" placeholder="Email address" required autoFocus />
                    <label htmlFor="inputPassword" className="sr-only">Password</label>
                    <input type="password" id="inputPassword" className="form-control" placeholder="Password" required />
                    <div className="checkbox mb-3">
                        <label>
                        <input type="checkbox" value="remember-me" /> Remember me
                        </label>
                    </div>
                    <button className="btn btn-lg btn-primary btn-block" type="submit">Login</button>
                    <p className="mt-5 mb-3 text-muted">&copy; { d.getFullYear() } MDS Digital Media Pvt. Ltd.</p>
                    <Link to="/dashboard">Dashboard</Link><br/>
                </form>
            </div>
        )
    }
}

export default Login
